/* shop/components/OrderCompany.svelte generated by Svelte v3.59.2 */
import {
	SvelteComponentDev,
	add_location,
	append_dev,
	attr_dev,
	component_subscribe,
	detach_dev,
	dispatch_dev,
	element,
	init,
	insert_dev,
	listen_dev,
	noop,
	prop_dev,
	run_all,
	safe_not_equal,
	space,
	text,
	validate_slots,
	validate_store
} from "svelte/internal";

import orderStore from "./../orderStore";
const file = "shop/components/OrderCompany.svelte";

function create_fragment(ctx) {
	let p0;
	let label0;
	let t1;
	let input0;
	let input0_value_value;
	let t2;
	let p1;
	let label1;
	let t4;
	let input1;
	let input1_value_value;
	let t5;
	let p2;
	let label2;
	let t7;
	let input2;
	let input2_value_value;
	let t8;
	let p3;
	let label3;
	let t10;
	let input3;
	let input3_value_value;
	let t11;
	let p4;
	let label4;
	let t13;
	let input4;
	let input4_value_value;
	let t14;
	let h30;
	let t16;
	let p5;
	let label5;
	let t18;
	let input5;
	let input5_value_value;
	let t19;
	let p6;
	let label6;
	let t21;
	let input6;
	let input6_value_value;
	let t22;
	let p7;
	let label7;
	let t24;
	let input7;
	let input7_value_value;
	let t25;
	let h31;
	let t26;
	let small;
	let t28;
	let p8;
	let label8;
	let t30;
	let input8;
	let input8_value_value;
	let t31;
	let p9;
	let label9;
	let t33;
	let input9;
	let input9_value_value;
	let t34;
	let p10;
	let label10;
	let t36;
	let input10;
	let input10_value_value;
	let t37;
	let p11;
	let label11;
	let t39;
	let textarea;
	let textarea_value_value;
	let mounted;
	let dispose;

	const block = {
		c: function create() {
			p0 = element("p");
			label0 = element("label");
			label0.textContent = "Název firmy";
			t1 = space();
			input0 = element("input");
			t2 = space();
			p1 = element("p");
			label1 = element("label");
			label1.textContent = "IČ";
			t4 = space();
			input1 = element("input");
			t5 = space();
			p2 = element("p");
			label2 = element("label");
			label2.textContent = "Kontaktní osoba";
			t7 = space();
			input2 = element("input");
			t8 = space();
			p3 = element("p");
			label3 = element("label");
			label3.textContent = "Email kontaktní osoby";
			t10 = space();
			input3 = element("input");
			t11 = space();
			p4 = element("p");
			label4 = element("label");
			label4.textContent = "Telefon kontaktní osoby";
			t13 = space();
			input4 = element("input");
			t14 = space();
			h30 = element("h3");
			h30.textContent = "Fakturační adresa";
			t16 = space();
			p5 = element("p");
			label5 = element("label");
			label5.textContent = "Ulice";
			t18 = space();
			input5 = element("input");
			t19 = space();
			p6 = element("p");
			label6 = element("label");
			label6.textContent = "Město";
			t21 = space();
			input6 = element("input");
			t22 = space();
			p7 = element("p");
			label7 = element("label");
			label7.textContent = "PSČ";
			t24 = space();
			input7 = element("input");
			t25 = space();
			h31 = element("h3");
			t26 = text("Dodací adresa\n    ");
			small = element("small");
			small.textContent = "(pokud se liší od fakturační)";
			t28 = space();
			p8 = element("p");
			label8 = element("label");
			label8.textContent = "Ulice";
			t30 = space();
			input8 = element("input");
			t31 = space();
			p9 = element("p");
			label9 = element("label");
			label9.textContent = "Město";
			t33 = space();
			input9 = element("input");
			t34 = space();
			p10 = element("p");
			label10 = element("label");
			label10.textContent = "PSČ";
			t36 = space();
			input10 = element("input");
			t37 = space();
			p11 = element("p");
			label11 = element("label");
			label11.textContent = "Poznámka";
			t39 = space();
			textarea = element("textarea");
			attr_dev(label0, "for", "company_name");
			add_location(label0, file, 22, 4, 514);
			attr_dev(input0, "type", "text");
			input0.required = true;
			attr_dev(input0, "id", "company_name");

			input0.value = input0_value_value = /*$orderStore*/ ctx[0].company_name
			? /*$orderStore*/ ctx[0].company_name
			: "";

			add_location(input0, file, 23, 4, 564);
			add_location(p0, file, 21, 0, 506);
			attr_dev(label1, "for", "company_id");
			add_location(label1, file, 32, 4, 798);
			attr_dev(input1, "type", "text");
			input1.required = true;
			attr_dev(input1, "id", "company_id");

			input1.value = input1_value_value = /*$orderStore*/ ctx[0].company_id
			? /*$orderStore*/ ctx[0].company_id
			: "";

			add_location(input1, file, 33, 4, 837);
			add_location(p1, file, 31, 0, 790);
			attr_dev(label2, "for", "name_and_surname");
			add_location(label2, file, 42, 4, 1063);
			attr_dev(input2, "type", "text");
			input2.required = true;
			attr_dev(input2, "id", "name_and_surname");

			input2.value = input2_value_value = /*$orderStore*/ ctx[0].name_and_surname
			? /*$orderStore*/ ctx[0].name_and_surname
			: "";

			add_location(input2, file, 43, 4, 1121);
			add_location(p2, file, 41, 0, 1055);
			attr_dev(label3, "for", "email");
			add_location(label3, file, 52, 4, 1371);
			attr_dev(input3, "type", "email");
			input3.required = true;
			attr_dev(input3, "id", "email");

			input3.value = input3_value_value = /*$orderStore*/ ctx[0].email
			? /*$orderStore*/ ctx[0].email
			: "";

			add_location(input3, file, 53, 4, 1424);
			add_location(p3, file, 51, 0, 1363);
			attr_dev(label4, "for", "phone");
			add_location(label4, file, 62, 4, 1631);
			attr_dev(input4, "type", "text");
			input4.required = true;
			attr_dev(input4, "id", "phone");

			input4.value = input4_value_value = /*$orderStore*/ ctx[0].phone
			? /*$orderStore*/ ctx[0].phone
			: "";

			add_location(input4, file, 63, 4, 1686);
			add_location(p4, file, 61, 0, 1623);
			add_location(h30, file, 71, 0, 1884);
			attr_dev(label5, "for", "address_street");
			add_location(label5, file, 74, 4, 1920);
			attr_dev(input5, "type", "text");
			input5.required = true;
			attr_dev(input5, "id", "address_street");

			input5.value = input5_value_value = /*$orderStore*/ ctx[0].address_stree
			? /*$orderStore*/ ctx[0].address_stree
			: "";

			add_location(input5, file, 75, 4, 1966);
			add_location(p5, file, 73, 0, 1912);
			attr_dev(label6, "for", "address_city");
			add_location(label6, file, 84, 4, 2206);
			attr_dev(input6, "type", "text");
			input6.required = true;
			attr_dev(input6, "id", "address_city");

			input6.value = input6_value_value = /*$orderStore*/ ctx[0].address_city
			? /*$orderStore*/ ctx[0].address_city
			: "";

			add_location(input6, file, 85, 4, 2250);
			add_location(p6, file, 83, 0, 2198);
			attr_dev(label7, "for", "address_zip");
			add_location(label7, file, 94, 4, 2484);
			attr_dev(input7, "type", "text");
			input7.required = true;
			attr_dev(input7, "id", "address_zip");

			input7.value = input7_value_value = /*$orderStore*/ ctx[0].address_zip
			? /*$orderStore*/ ctx[0].address_zip
			: "";

			add_location(input7, file, 95, 4, 2525);
			add_location(p7, file, 93, 0, 2476);
			add_location(small, file, 105, 4, 2774);
			add_location(h31, file, 103, 0, 2747);
			attr_dev(label8, "for", "delivery_address_street");
			add_location(label8, file, 109, 4, 2834);
			attr_dev(input8, "type", "text");
			attr_dev(input8, "id", "delivery_address_street");

			input8.value = input8_value_value = /*$orderStore*/ ctx[0].delivery_address_street
			? /*$orderStore*/ ctx[0].delivery_address_street
			: "";

			add_location(input8, file, 110, 4, 2889);
			add_location(p8, file, 108, 0, 2826);
			attr_dev(label9, "for", "delivery_address_city");
			add_location(label9, file, 118, 4, 3150);
			attr_dev(input9, "type", "text");
			attr_dev(input9, "id", "delivery_address_city");

			input9.value = input9_value_value = /*$orderStore*/ ctx[0].delivery_address_city
			? /*$orderStore*/ ctx[0].delivery_address_city
			: "";

			add_location(input9, file, 119, 4, 3203);
			add_location(p9, file, 117, 0, 3142);
			attr_dev(label10, "for", "delivery_address_zip");
			add_location(label10, file, 127, 4, 3456);
			attr_dev(input10, "type", "text");
			attr_dev(input10, "id", "delivery_address_zip");

			input10.value = input10_value_value = /*$orderStore*/ ctx[0].delivery_address_zip
			? /*$orderStore*/ ctx[0].delivery_address_zip
			: "";

			add_location(input10, file, 128, 4, 3506);
			add_location(p10, file, 126, 0, 3448);
			attr_dev(label11, "for", "order_description");
			add_location(label11, file, 136, 4, 3755);
			attr_dev(textarea, "id", "order_description");

			textarea.value = textarea_value_value = /*$orderStore*/ ctx[0].order_description
			? /*$orderStore*/ ctx[0].order_description
			: '';

			add_location(textarea, file, 137, 4, 3807);
			add_location(p11, file, 135, 0, 3747);
		},
		l: function claim(nodes) {
			throw new Error("options.hydrate only works if the component was compiled with the `hydratable: true` option");
		},
		m: function mount(target, anchor) {
			insert_dev(target, p0, anchor);
			append_dev(p0, label0);
			append_dev(p0, t1);
			append_dev(p0, input0);
			insert_dev(target, t2, anchor);
			insert_dev(target, p1, anchor);
			append_dev(p1, label1);
			append_dev(p1, t4);
			append_dev(p1, input1);
			insert_dev(target, t5, anchor);
			insert_dev(target, p2, anchor);
			append_dev(p2, label2);
			append_dev(p2, t7);
			append_dev(p2, input2);
			insert_dev(target, t8, anchor);
			insert_dev(target, p3, anchor);
			append_dev(p3, label3);
			append_dev(p3, t10);
			append_dev(p3, input3);
			insert_dev(target, t11, anchor);
			insert_dev(target, p4, anchor);
			append_dev(p4, label4);
			append_dev(p4, t13);
			append_dev(p4, input4);
			insert_dev(target, t14, anchor);
			insert_dev(target, h30, anchor);
			insert_dev(target, t16, anchor);
			insert_dev(target, p5, anchor);
			append_dev(p5, label5);
			append_dev(p5, t18);
			append_dev(p5, input5);
			insert_dev(target, t19, anchor);
			insert_dev(target, p6, anchor);
			append_dev(p6, label6);
			append_dev(p6, t21);
			append_dev(p6, input6);
			insert_dev(target, t22, anchor);
			insert_dev(target, p7, anchor);
			append_dev(p7, label7);
			append_dev(p7, t24);
			append_dev(p7, input7);
			insert_dev(target, t25, anchor);
			insert_dev(target, h31, anchor);
			append_dev(h31, t26);
			append_dev(h31, small);
			insert_dev(target, t28, anchor);
			insert_dev(target, p8, anchor);
			append_dev(p8, label8);
			append_dev(p8, t30);
			append_dev(p8, input8);
			insert_dev(target, t31, anchor);
			insert_dev(target, p9, anchor);
			append_dev(p9, label9);
			append_dev(p9, t33);
			append_dev(p9, input9);
			insert_dev(target, t34, anchor);
			insert_dev(target, p10, anchor);
			append_dev(p10, label10);
			append_dev(p10, t36);
			append_dev(p10, input10);
			insert_dev(target, t37, anchor);
			insert_dev(target, p11, anchor);
			append_dev(p11, label11);
			append_dev(p11, t39);
			append_dev(p11, textarea);

			if (!mounted) {
				dispose = [
					listen_dev(input0, "blur", /*blur_handler*/ ctx[2], false, false, false, false),
					listen_dev(input1, "blur", /*blur_handler_1*/ ctx[3], false, false, false, false),
					listen_dev(input2, "blur", /*blur_handler_2*/ ctx[4], false, false, false, false),
					listen_dev(input3, "blur", /*blur_handler_3*/ ctx[5], false, false, false, false),
					listen_dev(input4, "blur", /*blur_handler_4*/ ctx[6], false, false, false, false),
					listen_dev(input5, "blur", /*blur_handler_5*/ ctx[7], false, false, false, false),
					listen_dev(input6, "blur", /*blur_handler_6*/ ctx[8], false, false, false, false),
					listen_dev(input7, "blur", /*blur_handler_7*/ ctx[9], false, false, false, false),
					listen_dev(input8, "blur", /*blur_handler_8*/ ctx[10], false, false, false, false),
					listen_dev(input9, "blur", /*blur_handler_9*/ ctx[11], false, false, false, false),
					listen_dev(input10, "blur", /*blur_handler_10*/ ctx[12], false, false, false, false),
					listen_dev(textarea, "blur", /*blur_handler_11*/ ctx[13], false, false, false, false)
				];

				mounted = true;
			}
		},
		p: function update(ctx, [dirty]) {
			if (dirty & /*$orderStore*/ 1 && input0_value_value !== (input0_value_value = /*$orderStore*/ ctx[0].company_name
			? /*$orderStore*/ ctx[0].company_name
			: "") && input0.value !== input0_value_value) {
				prop_dev(input0, "value", input0_value_value);
			}

			if (dirty & /*$orderStore*/ 1 && input1_value_value !== (input1_value_value = /*$orderStore*/ ctx[0].company_id
			? /*$orderStore*/ ctx[0].company_id
			: "") && input1.value !== input1_value_value) {
				prop_dev(input1, "value", input1_value_value);
			}

			if (dirty & /*$orderStore*/ 1 && input2_value_value !== (input2_value_value = /*$orderStore*/ ctx[0].name_and_surname
			? /*$orderStore*/ ctx[0].name_and_surname
			: "") && input2.value !== input2_value_value) {
				prop_dev(input2, "value", input2_value_value);
			}

			if (dirty & /*$orderStore*/ 1 && input3_value_value !== (input3_value_value = /*$orderStore*/ ctx[0].email
			? /*$orderStore*/ ctx[0].email
			: "") && input3.value !== input3_value_value) {
				prop_dev(input3, "value", input3_value_value);
			}

			if (dirty & /*$orderStore*/ 1 && input4_value_value !== (input4_value_value = /*$orderStore*/ ctx[0].phone
			? /*$orderStore*/ ctx[0].phone
			: "") && input4.value !== input4_value_value) {
				prop_dev(input4, "value", input4_value_value);
			}

			if (dirty & /*$orderStore*/ 1 && input5_value_value !== (input5_value_value = /*$orderStore*/ ctx[0].address_stree
			? /*$orderStore*/ ctx[0].address_stree
			: "") && input5.value !== input5_value_value) {
				prop_dev(input5, "value", input5_value_value);
			}

			if (dirty & /*$orderStore*/ 1 && input6_value_value !== (input6_value_value = /*$orderStore*/ ctx[0].address_city
			? /*$orderStore*/ ctx[0].address_city
			: "") && input6.value !== input6_value_value) {
				prop_dev(input6, "value", input6_value_value);
			}

			if (dirty & /*$orderStore*/ 1 && input7_value_value !== (input7_value_value = /*$orderStore*/ ctx[0].address_zip
			? /*$orderStore*/ ctx[0].address_zip
			: "") && input7.value !== input7_value_value) {
				prop_dev(input7, "value", input7_value_value);
			}

			if (dirty & /*$orderStore*/ 1 && input8_value_value !== (input8_value_value = /*$orderStore*/ ctx[0].delivery_address_street
			? /*$orderStore*/ ctx[0].delivery_address_street
			: "") && input8.value !== input8_value_value) {
				prop_dev(input8, "value", input8_value_value);
			}

			if (dirty & /*$orderStore*/ 1 && input9_value_value !== (input9_value_value = /*$orderStore*/ ctx[0].delivery_address_city
			? /*$orderStore*/ ctx[0].delivery_address_city
			: "") && input9.value !== input9_value_value) {
				prop_dev(input9, "value", input9_value_value);
			}

			if (dirty & /*$orderStore*/ 1 && input10_value_value !== (input10_value_value = /*$orderStore*/ ctx[0].delivery_address_zip
			? /*$orderStore*/ ctx[0].delivery_address_zip
			: "") && input10.value !== input10_value_value) {
				prop_dev(input10, "value", input10_value_value);
			}

			if (dirty & /*$orderStore*/ 1 && textarea_value_value !== (textarea_value_value = /*$orderStore*/ ctx[0].order_description
			? /*$orderStore*/ ctx[0].order_description
			: '')) {
				prop_dev(textarea, "value", textarea_value_value);
			}
		},
		i: noop,
		o: noop,
		d: function destroy(detaching) {
			if (detaching) detach_dev(p0);
			if (detaching) detach_dev(t2);
			if (detaching) detach_dev(p1);
			if (detaching) detach_dev(t5);
			if (detaching) detach_dev(p2);
			if (detaching) detach_dev(t8);
			if (detaching) detach_dev(p3);
			if (detaching) detach_dev(t11);
			if (detaching) detach_dev(p4);
			if (detaching) detach_dev(t14);
			if (detaching) detach_dev(h30);
			if (detaching) detach_dev(t16);
			if (detaching) detach_dev(p5);
			if (detaching) detach_dev(t19);
			if (detaching) detach_dev(p6);
			if (detaching) detach_dev(t22);
			if (detaching) detach_dev(p7);
			if (detaching) detach_dev(t25);
			if (detaching) detach_dev(h31);
			if (detaching) detach_dev(t28);
			if (detaching) detach_dev(p8);
			if (detaching) detach_dev(t31);
			if (detaching) detach_dev(p9);
			if (detaching) detach_dev(t34);
			if (detaching) detach_dev(p10);
			if (detaching) detach_dev(t37);
			if (detaching) detach_dev(p11);
			mounted = false;
			run_all(dispose);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_fragment.name,
		type: "component",
		source: "",
		ctx
	});

	return block;
}

function instance($$self, $$props, $$invalidate) {
	let $orderStore;
	validate_store(orderStore, 'orderStore');
	component_subscribe($$self, orderStore, $$value => $$invalidate(0, $orderStore = $$value));
	let { $$slots: slots = {}, $$scope } = $$props;
	validate_slots('OrderCompany', slots, []);

	const setValue = (name, value, inputElm) => {
		if (inputElm.checkValidity() && orderStore.setProp(name, value)) {
			inputElm.classList.remove('invalid');
		} else {
			inputElm.classList.add('invalid');
		}
	};

	const writable_props = [];

	Object.keys($$props).forEach(key => {
		if (!~writable_props.indexOf(key) && key.slice(0, 2) !== '$$' && key !== 'slot') console.warn(`<OrderCompany> was created with unknown prop '${key}'`);
	});

	const blur_handler = e => setValue('company_name', e.target.value, e.target);
	const blur_handler_1 = e => setValue('company_id', e.target.value, e.target);
	const blur_handler_2 = e => setValue('name_and_surname', e.target.value, e.target);
	const blur_handler_3 = e => setValue('email', e.target.value, e.target);
	const blur_handler_4 = e => setValue('phone', e.target.value, e.target);
	const blur_handler_5 = e => setValue('address_street', e.target.value, e.target);
	const blur_handler_6 = e => setValue('address_city', e.target.value, e.target);
	const blur_handler_7 = e => setValue('address_zip', e.target.value, e.target);
	const blur_handler_8 = e => setValue('delivery_address_street', e.target.value, e.target);
	const blur_handler_9 = e => setValue('delivery_address_city', e.target.value, e.target);
	const blur_handler_10 = e => setValue('delivery_address_zip', e.target.value, e.target);
	const blur_handler_11 = e => setValue('order_description', e.target.value, e.target);
	$$self.$capture_state = () => ({ orderStore, setValue, $orderStore });

	return [
		$orderStore,
		setValue,
		blur_handler,
		blur_handler_1,
		blur_handler_2,
		blur_handler_3,
		blur_handler_4,
		blur_handler_5,
		blur_handler_6,
		blur_handler_7,
		blur_handler_8,
		blur_handler_9,
		blur_handler_10,
		blur_handler_11
	];
}

class OrderCompany extends SvelteComponentDev {
	constructor(options) {
		super(options);
		init(this, options, instance, create_fragment, safe_not_equal, {});

		dispatch_dev("SvelteRegisterComponent", {
			component: this,
			tagName: "OrderCompany",
			options,
			id: create_fragment.name
		});
	}
}

export default OrderCompany;